import { useController, useFormContext } from 'react-hook-form';

import { RadioGroup } from 'shared/components/RadioGroup';

import type { RadioGroupProps as MuiRadioGroupProps } from '@mui/material';
import type { FC } from 'react';

interface FormRadioGrpupProps extends Omit<MuiRadioGroupProps, 'name'> {
  name: string;
}

export const FormRadioGroup: FC<FormRadioGrpupProps> = ({
  name,
  ref,
  ...props
}) => {
  const { control } = useFormContext();
  const { field } = useController({ control, name });

  return <RadioGroup {...field} ref={ref} {...props} />;
};
